/*
 * File: apiMiddleware.ts
 * Project: little-murrary-sparkles
 * -----
 * Last Modified: 02 Sep 2021 6:53:48 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Middleware, MiddlewareAPI, isRejectedWithValue } from '@reduxjs/toolkit';

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    console.log('middleware', action);
    switch (action.payload.originalStatus) {
      case 401:
        console.warn('Need to refetch auth token');
        break;

      // case 404:
      //   message.error('Unable to find resource. Please refresh and try again!');
      //   break;
    }
  }

  return next(action);
};
